import toast from 'react-hot-toast'
import { useCarromm } from '../../context/carrom'

function Login () {
  const carrom = useCarromm()
  const handleOnsubmit = e => {
    e.preventDefault()
    const passcode = process.env.REACT_APP_PASSCODE || 'carromm@123'
    const password = e.target.passcode.value
    if (password !== passcode) {
      toast.error('Ungültiges Passwort')
      return false
    }
    localStorage.setItem('user', true)
    carrom.setIsLogin(true)
  }
  return (
    <div class='container mx-auto overflow-y-hidden'>
      <div class='flex justify-center items-center h-[90vh]'>
        <div class='w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/4 flex flex-col items-center'>
          <center>
            <img class='mb-4' alt='' src='./assets/image/logo.png' />
          </center>
          <form action='' onSubmit={handleOnsubmit} class='w-full'>
            <div class='mb-4'>
              <label for='exampleInputPassword1' class='block mb-1'>
                Kennwort
              </label>
              <input
                type='password'
                class='form-control'
                name='passcode'
                id='exampleInputPassword1'
                placeholder='Kennwort'
              />
            </div>
            <div class='mt-2'>
              <button class='focus:outline-none text-white bg-[#3dd5f3] hover:bg-[#31d2f2] focus:ring-4 focus:ring-[#0dcaf0] font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 btn btn-info btn-block w-full'>
                Anmelden
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Login
